import React from "react";
import Typography from "@material-ui/core/Typography";
const SalesJourney = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Sales Journey
      </Typography>
      <Typography paragraph variant="h5">
        Track salesman activity during approaching customer
      </Typography>
      <Typography paragraph variant="body1">
        Sales Journey is one of the features under the CRM module to perform
        pre-sales transactions particularly to manage the company's salesman
        activity and assignment during potential customer approachment. It
        contains any information regarding the potential customer visit
        activity, pre-sales journey plan & actual date, the company's item stock
        brought during pre-sales, and the team members assigned for the
        pre-sales agenda.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Sales Journey
        list. It is displayed like a table that contains download functions,
        sort, filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Journey ID</b>
        <br />
        Indicates the ID of the Sales Journey.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Journey Name</b>
        <br />
        Indicates the name of the Sales Journey.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Journey Status</b>
        <br />
        Indicates the pre-sales journey status of the Sales Journey. There are 4
        statuses: Unstarted, Started, Finished, and Cancelled.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Plan Start Date</b>
        <br />
        Indicates the plan start date of the Sales Journey.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Plan End Date</b>
        <br />
        Indicates the plan end date of the Sales Journey.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Assigned To</b>
        <br />
        Indicates who takes the main assignment of the Sales Journey.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 2 buttons that appear on each row of Sales Journey
        data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Journey Detail</b>
        <br />
        This button is used to navigate to the Sales Journey detail which
        contains some tabs with details below:
        <ul>
          <li>
            <b>Sales Journeys</b> : This tab is to display the Sales Journey
            data and the Visit activities detail.
          </li>
          <li>
            <b>Teams</b> : This tab is to display any Teams assigned to the
            Sales Journey.
          </li>
          <li>
            <b>Stocks</b> : This tab is to display any Stock brought during
            Sales Journey.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Sales Journey.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the Sales
            Journey.
          </li>
        </ul>
        When opening the Sales Journey detail, there will be more than 1 button
        appearing on the top section depending on the Sales Journey status. The
        first button is 'Edit Journey' which is used to edit the Sales Journey
        data. The button only appears when the Sales Journey status is not
        'Finished' and 'Cancelled'. The other buttons are 'Start Journey' and
        'Cancel Journey', which appear when Sales Journey status is 'Unstarted'.
        The last button is 'Finish Journey' where this button appears when Sales
        Journey Status is 'Started'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Sales Journey</b>
        <br />
        This button only appears if the Sales Journey status is 'Unstarted'. It
        is used to delete the Sales Journey data. The Sales Journey data is
        undeletable once it has relations with other documents.
      </Typography>
    </React.Fragment>
  );
};

export default SalesJourney;
